const acceptedReplacementFileUploadTypes = ["image/jpeg", "image/png", "image/jpg", "application/pdf"];

export default acceptedReplacementFileUploadTypes;
